import * as THREE from "three";
import Experience from "../Experience.js";

export default class Floor {
  constructor(_textureFloor) {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.room = this.experience.room;
    this.resources = this.experience.resources;
    this.sizes = this.experience.sizes;
    this.camera = this.experience.camera;
    this.saveRoom = this.room.saveRoom;

    this.textureFloor = _textureFloor || null;

    this.sizeScene = this.experience.sizeScene;

    this.shapeRoom = this.room.shape;
    this.measureWalls = this.room.getWallSegments();

    this.normalTexture = this.experience.textureLoader.load(
      "./products/floor/normalMap.jpg"
    );

    this.roughnessMap = this.experience.textureLoader.load(
      "./products/wall/roughtMap.png"
    );

    this.wallsGroupPosition = this.room.getWallsGroupPosition();

    this.initialize();
  }

  initialize() {
    this.measureWalls = this.room.getWallSegments();

    this.setGeometry();
    if (this.textureFloor !== null) {
      this.setTexture(this.textureFloor);
    }
    this.setMaterial();
    this.setMesh();
  }

  setGeometry() {
    // Créer la forme du sol en fonction des segments de mur
    const shape = new THREE.Shape();
    const startPoint = this.measureWalls[0];
    shape.moveTo(startPoint.x, startPoint.z);

    for (let i = 1; i < this.measureWalls.length; i++) {
      shape.lineTo(this.measureWalls[i].x, this.measureWalls[i].z);
    }
    // Fermer la forme du sol
    shape.lineTo(startPoint.x, startPoint.z);

    // Créer la géométrie du sol à partir de la forme
    this.geometry = new THREE.ShapeGeometry(shape);
  }

  setTexture(srcTexture) {
    const srcNormalMap = srcTexture.replace("product.jpg", "normalMap.jpg");

    this.textures = {};

    this.experience.textureLoader.load(srcTexture, (texture) => {
      this.textures.color = texture;
      this.textures.color.colorSpace = THREE.SRGBColorSpace;

      const maxX = Math.max(...this.measureWalls.map((point) => point.x));

      const maxZ = Math.max(...this.measureWalls.map((point) => point.z));

      const width = maxX;
      const height = maxZ;

      const repeatX = width / 16;
      const repeatY = height / 16;

      this.textures.color.repeat.set(repeatX, repeatY);
      this.textures.color.wrapS = THREE.RepeatWrapping;
      this.textures.color.wrapT = THREE.RepeatWrapping;

      this.material.map = this.textures.color;
      this.material.needsUpdate = true;

      this.updateNormalMap(srcNormalMap);

      this.saveRoom.setTextureFloor(srcTexture);
    });
  }

  updateNormalMap(newNormalTexture) {
    this.experience.textureLoader.load(newNormalTexture, (texture) => {
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.offset.set(0.75, 0.75);
      texture.repeat.set(0.17, 0.17); //0.43, 0.3
      this.normalTexture = texture;
      this.material.normalMap = this.normalTexture;
      this.material.needsUpdate = true;
    });
  }

  setMaterial() {
    const maxX = Math.max(...this.measureWalls.map((point) => point.x));

    const maxZ = Math.max(...this.measureWalls.map((point) => point.z));

    this.geometry.computeBoundingBox();
    this.geometry.computeVertexNormals(); // Important pour les ombres et les reflets
    this.geometry.normalizeNormals();

    const boundingBox = this.geometry.boundingBox;
    const width = boundingBox.max.x - boundingBox.min.x;
    const height = boundingBox.max.y - boundingBox.min.y;

    const repeatX = width / 2.4;
    const repeatY = height / 0.8;

    this.roughnessMap.repeat.set(repeatX, repeatY);
    this.roughnessMap.wrapS = THREE.RepeatWrapping;
    this.roughnessMap.wrapT = THREE.RepeatWrapping;
    this.normalTexture.offset.set(0.75, 0.75);
    this.normalTexture.repeat.set(0.17, 0.17);
    this.normalTexture.wrapS = THREE.RepeatWrapping;
    this.normalTexture.wrapT = THREE.RepeatWrapping;

    this.material = new THREE.MeshStandardMaterial({
      side: THREE.DoubleSide,
      roughness: 0.5,
      metalness: 0.1,
      //roughnessMap: this.roughnessMap,
      normalMap: this.normalTexture,
    });
  }

  setMesh() {
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.rotation.x = -Math.PI * 0.5; // Aligner le sol horizontalement

    // Calculer les coordonnées du centre

    const maxX = Math.max(...this.measureWalls.map((point) => point.x));
    const maxZ = Math.max(...this.measureWalls.map((point) => point.z));

    // Placer le sol au centre de la pièce
    this.mesh.rotation.x = Math.PI / 2;
    this.mesh.position.copy(new THREE.Vector3(0 - maxX / 2, 0, 0 - maxZ / 2));
    this.mesh.receiveShadow = true;
    this.mesh.name = "floor";
    this.mesh.userData.type = "floor";

    this.scene.add(this.mesh);
  }

  /**
   * Delete floor
   */
  deleteFloor() {
    if (this.mesh) {
      this.scene.remove(this.mesh);
      this.mesh.children.forEach((child) => {
        if (child.geometry) child.geometry.dispose();
      });
    }
  }
}
